import { Sparkles } from 'lucide-react';

/** “New” pill when the unit has not been opened yet (in progress + review tabs). */
export function UnitCardHeaderNewBadge({ visible }: { visible: boolean }) {
    if (!visible) return null;
    return (
        <div className="absolute top-2 right-2 z-10 flex items-center gap-1 rounded-full bg-yellow-100 px-2 py-1 text-xs font-semibold text-yellow-800 shadow-sm">
            <Sparkles size={12} className="text-yellow-600" />
            <span>New</span>
        </div>
    );
}
